import React from 'react';

const DropDown = (props) => {
  const inputClasses = 'shadow appearance-none border rounded w-full py-2 px-3 text-gray-400 text-xs leading-tight focus:outline-none focus:shadow-outline';
  function onChange(value) {
    props.onChange(value);
  }

  if (props.data.length === 0 || !props.data) {
    return <select className={inputClasses} disabled />;
  }
  const options = props.data.map((option) => {
    return (
      <option key={option.id} value={option.id}>
        {option.descripcion}
      </option>
    );
  });

  return (
    <select
      className={inputClasses}
      id={props.id}
      required={props.required}
      onChange={(event) => onChange(event.target.value)}
    >
      <option value=''>Seleccione</option>
      {options}
    </select>
  );
};
export default DropDown;
